import courses from './courses';
import feedTrails from './feedTrails';
import releaseSites from './releaseSites';
import labels from './labels';
import huntEvents from './huntEvents';
import userTracks from './userTracks';
import trapHistory from './trapHistory';
import highlights from './highlights';

export default {
  courses,
  feedTrails,
  releaseSites,
  labels,
  huntEvents,
  userTracks,
  trapHistory,
  highlights,
};
